module.exports = __webpack_public_path__ + "media/images/default/pages/public_sciences/main/2-4d2ccc394bf5623c7dcf9290e1f84555.svg";